import React, { Fragment, lazy } from "react";
import { useNavigate } from "react-router-dom";
import { CFW_GLOBAL } from "@genericComponents/CFW.js";
import { GeneratePath } from "@genericComponents/Common.js";
import { User } from "@genericComponents/User.js";
import Label from "@controls/Label.js";
const useProductLanguageCode =
  await import("@customHooks/useProductLanguageCode.js").then(
    (mod) => mod.useProductLanguageCode,
  );
const CommaFormatDigit = await import("@asyncImports/CommaFormatDigit.js").then(
  (mod) => mod.CommaFormatDigit,
);
const HydrationLoadScript = lazy(
  () => import("@controls/HydrationLoadScripts.js"),
);
const DisplayPoints = () => {
  const { productCode, languageCode, pathName } = useProductLanguageCode(true);
  const navigate = useNavigate();
  const AddPoints = () => {
    navigate(GeneratePath(languageCode, productCode, "AddPoints"));
  };
  return User.IsLoggedIn() &&
    !pathName.toLowerCase().includes("/dailytimerecord/") &&
    !pathName.toLowerCase().includes("/viewitem/") &&
    !pathName.toLowerCase().includes("/addpoints") &&
    !pathName.toLowerCase().includes("/auth/linkedin/callback") ? (
    <div className="pointsEarned initiallyHidden">
      <HydrationLoadScript
        postEvt={() => {
          import("@css/pointsEarnedStyles.css");
        }}
      />
      <b>{CommaFormatDigit(User.Points(), false)}</b>&nbsp;
      <Label category={CFW_GLOBAL} tranVal="338" />
      &nbsp;|&nbsp;
      <button
        type="button"
        onClick={AddPoints}
        className="buttonLink addPoints"
      >
        <Label category={CFW_GLOBAL} tranVal="5" />
      </button>
    </div>
  ) : (
    <Fragment />
  );
};
export default DisplayPoints;
